import { AnyAction, ThunkDispatch } from '@reduxjs/toolkit'
import { Dispatch } from 'react'
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux'
import type { RootState, AppDispatch } from './store'

export const useAppDispatch = (): ThunkDispatch<never, null, AnyAction> &
    ThunkDispatch<never, undefined, AnyAction> &
    Dispatch<AnyAction> => useDispatch<AppDispatch>()
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector
